import { useState, useEffect, useCallback } from 'react';
import { storageService } from '../services/storage';



export interface TableData {
  tableId: string;
  tableNumber: number;
  capacity: number;
  location: string;
  status: string;
  createdAt: string;
  restaurantId?: string;
  restaurantName?: string;
  restaurantLogo?: string;
  tableSigned?: string; // JWT completo para enviar al backend
}

export interface UseTableAuthReturn {
  tableData: TableData | null;
  isAuthenticated: boolean;
  clearTableData: () => void;
  debugStorage: () => void;
}

export function useTableAuth(): UseTableAuthReturn {
  const [tableData, setTableData] = useState<TableData | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Cargar datos de la mesa al inicializar
  useEffect(() => {
    const loadTableData = async () => {
      try {
        // Intentar cargar desde storageService primero
        let savedTableData = await storageService.getTableData();
        
        // Si no se encuentra, intentar desde localStorage directo
        if (!savedTableData && typeof window !== 'undefined') {
          const directTableData = localStorage.getItem('tableData');
          if (directTableData) {
            try {
              savedTableData = JSON.parse(directTableData);
              console.log('✅ Mesa cargada desde localStorage directo:', savedTableData);
            } catch (parseError) {
              console.error('❌ Error parseando datos de mesa del localStorage:', parseError);
            }
          }
        }
        
        if (savedTableData) {
          setTableData(savedTableData);
          setIsAuthenticated(true);
          console.log('✅ Mesa cargada:', savedTableData);
        } else {
          console.log('❌ No se encontraron datos de mesa en storage');
        }
      } catch (error) {
        console.error('❌ Error al cargar datos de la mesa:', error);
      }
    };

    loadTableData();
  }, []);

  // Función para limpiar datos de la mesa
  const clearTableData = useCallback(async () => {
    try {
      await storageService.clearTableData();
      setTableData(null);
      setIsAuthenticated(false);
      console.log('✅ Datos de mesa limpiados');
    } catch (error) {
      console.error('❌ Error al limpiar datos de la mesa:', error);
    }
  }, []);



  // Función para debug del storage
  const debugStorage = useCallback(async () => {
    try {
      console.log('🔍 Debug del storage:');
      const tableData = await storageService.getTableData();
      console.log('Datos de mesa:', tableData);
      
      // Mostrar todos los datos del localStorage
      if (typeof window !== 'undefined' && window.localStorage) {
        console.log('localStorage completo:');
        for (let i = 0; i < window.localStorage.length; i++) {
          const key = window.localStorage.key(i);
          if (key) {
            const value = window.localStorage.getItem(key);
            console.log(`${key}:`, value);
          }
        }
      }
    } catch (error) {
      console.error('❌ Error en debug del storage:', error);
    }
  }, []);

  return {
    tableData,
    isAuthenticated,
    clearTableData,
    debugStorage,
  };
} 